import React from 'react';
import { Route, Routes} from 'react-router-dom';
import Navigation from './routes/navigation/navigation.component'
import HomeNew from './components/home/home-new.component';
import Services from './components/services/services.component';
import About from './components/about/about.component';
import Contact from './components/contact/contact.component';
import './App.css';

const App = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<Navigation />}>
          <Route index element={<HomeNew />} />
          <Route path="services/*" element={<Services />} /> 
          <Route path="contact" element={<Contact />} />
          <Route path="about" element={<About />} />
        </Route>
      </Routes> 
    </>
  );
};

export default App;
 